export default "__VITE_ASSET__44b7d1f3__"